import { createContext, useContext } from 'react';
export const DropEventContext = createContext(null);
export const useDropEventContext = () => {
    const context = useContext(DropEventContext);
    if (!context) {
        throw new Error('useDropEventContext must be used within a DropEventProvider');
    }
    return context;
};
